export const TableSelectors = {
    IsEditingCell: (state) => state.Table.isEditingCell,
    ColumnState: (state) => state.Table.columnState,
};
